module.exports = __webpack_public_path__ + "static/img/cat.6dfff608.gif";